import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icons/card-frame.png'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content" }
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-[25px]" }
const _hoisted_7 = { class: "text-center mt-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Card")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["trezo-card-dropdown-btn inline-block transition-all text-[26px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500", {
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }]),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "ri-more-fill" }, null, -1)
          ]), 2),
          _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Edit ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Delete ")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "p-[20px] md:p-[25px] rounded-[16px] bg-center bg-no-repeat bg-cover",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.image2})` })
        }, _cache[5] || (_cache[5] = [
          _createStaticVNode("<div class=\"mb-[7px] flex items-center justify-between\"><span class=\"block text-white font-medium text-xs\"> Virtual Card </span><span class=\"text-xl text-white leading-none\"><i class=\"ri-mastercard-fill\"></i></span></div><img src=\"" + _imports_0 + "\" alt=\"card-frame\"><h5 class=\"text-white font-semibold mt-[12px] mb-[50px]\" style=\"word-spacing:4px;\"> .... .... .... 1794 </h5><div class=\"flex items-center justify-between\"><span class=\"block text-white\"> David Farrior </span><span class=\"text-white block font-medium text-xs\"> EXP : 12/30 </span></div>", 4)
        ]), 4),
        _createElementVNode("div", {
          class: "p-[20px] md:p-[25px] rounded-[16px] bg-center bg-no-repeat bg-cover",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.image})` })
        }, _cache[6] || (_cache[6] = [
          _createStaticVNode("<div class=\"mb-[7px] flex items-center justify-between\"><span class=\"block text-white font-medium text-xs\"> Debit Card </span><span class=\"text-xl text-white leading-none\"><i class=\"ri-visa-fill\"></i></span></div><img src=\"" + _imports_0 + "\" alt=\"card-frame\"><h5 class=\"text-white font-semibold mt-[12px] mb-[50px]\" style=\"word-spacing:4px;\"> 5322 0520 0744 1794 </h5><div class=\"flex items-center justify-between\"><span class=\"block text-white\"> David Farrior </span><span class=\"text-white block font-medium text-xs\"> EXP : 12/30 </span></div>", 4)
        ]), 4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.cardModal && _ctx.stateStoreInstance.cardModal(...args)))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("span", { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add "),
            _createTextVNode(" Add Card ")
          ], -1)
        ]))
      ])
    ])
  ]))
}